import React from "react";
import { Helmet } from "react-helmet";
import { Route, Switch, withRouter } from "react-router";
import { ModuleContext } from "../components/authProvider/main";
import { Page404 } from "./404";
import DashboardPage from "./DashboardPage";
import ParametersPage from "./ParametersPage";
import BrowsePage from "./crud/BrowsePage";
import EditPage from "./crud/EditPage";
import ReadPage from "./crud/ReadPage";
import DataInsightsPage from "./data_insights/DataInsightsPage";
import { DevRoom } from "./dev-room/DevRoom";
import developmentPage from "./development/developmentPage";
import GraphsAnalyticsPage from "./graphs_analytics/GraphsAnalyticsPage";
import ViewProfilePage from "./profile/ViewProfilePage";
import ReportPage from "./reports/ReportPage";
import SaleAnalyticsPage from "./sales_insight/SalesAnalyticsPage";

class DefaultDashboardPage extends React.Component<any, {}> {
    static contextType = ModuleContext;
    public state = {
        isLoading: false,
        usuario: null,
    };

    getModulesLocal = ({ moduleName }: { moduleName: string }) => {
        const modulesLocal: any = localStorage.getItem('modules');
        const modulesLocalJson = JSON.parse(modulesLocal);
        let objectReturn: any = undefined
        for (const item of modulesLocalJson) {
            if (item.module_url === moduleName) {
                objectReturn = item;
                break;
            }
        }
        return objectReturn
    }

    componentDidUpdate(props: any) {
        const { module } = this.props.match.params;
        const moduleConfig = this.getModulesLocal(
            {
                moduleName: module
            }
        )
        if (!moduleConfig.module_url === module) {
            this.props.history.push("/dashboard");
        }
        if (this.context.name !== module) {
            var color = null;
            if (moduleConfig.module_url === module) {
                color = moduleConfig.module_color;
            }
            this.context.setModule(module, color);
            this.setState({ isLoading: false });
        }
    }

    componentDidMount = () => {
        const { module }: any = this.props.match.params;
        const moduleConfig = this.getModulesLocal(
            {
                moduleName: module
            }
        )
        if (!moduleConfig.module_url === module) {
            this.props.history.push("/dashboard");
        }
        if ((this.context.name !== module || this.context.color === null) && moduleConfig.module_color) {
            var color = null;
            if (moduleConfig.module_url === module) {
                color = moduleConfig.module_color;

            }
            this.context.setModule(module, color);
        }
    };

    render() {
        const { path } = this.props.match;
        const { module } = this.props.match.params;
        const moduleConfig = this.getModulesLocal(
            {
                moduleName: module
            }
        )
        if (!moduleConfig) {
            this.props.history.replace('/dashboard/configuracoes/404');
            return null;
        }
        if (this.state.isLoading === true) {
            return null;
        }
        // console.log("Props ::: ", this.props.location);
        // console.log("path :: ", path);
        // alert(path + '/parameters');
        return (
            <div className={module + "-page"}>
                <Helmet>
                    {/* <title>Brasmeg RH - {moduleConfig.fullName ?? moduleConfig.label}</title> */}
                    <title>Coxinha da Hora - {moduleConfig.module_full_name ?? moduleConfig.module_label}</title>
                </Helmet>
                <Switch>
                    <Route exact path={path} component={DashboardPage} />

                    <Route exact path={path + '/parameters'} component={ParametersPage} />


                    <Route exact path={path + '/dev-room'} component={DevRoom} />
                    <Route exact path={path + '/profile'} component={ViewProfilePage} />
                    {/* <Route exact path={path + '/xml_validators'} component={ReportAndCustomPage} /> */}
                    {/* {(this.props.location.pathname).includes("xml_vali") && (<Route exact path={path + "/:crud"} component={ReportAndCustomPage} />)} */}
                    {/* {(this.props.location.pathname).includes("graphics") && (<Route exact path={path + "/:crud"} component={ReportPage} />)} */}

                    {/* <Route exact path={path + '/estimates/:id'} component={EstimatesEditAddPage} /> */}
                    {/* <Route exact path={path + '/psm/add'} component={PSMEditAddPage} /> */}
                    {/* <Route exact path={path + '/estimates'} component={EstimatesBrowsePage} /> */}
                    {/* POSSIVEL ROTA DE EDICAO*/}
                    {/* <Route exact path={path + "/labs/add"} component={EditPage} /> */}
                    <Route exact path={path + "/404"} component={Page404} />
                    {(this.props.location.pathname).includes("developmen") && (<Route exact path={path + "/:crud"} component={developmentPage} />)}
                    {/* {(this.props.location.pathname).includes("reports") && (<Route exact path={path + "/:crud"} component={ReportPage} />)} */}
                    {(this.props.location.pathname).includes("graphics") && (<Route exact path={path + "/:crud"} component={ReportPage} />)}
                    {/* {(this.props.location.pathname).includes("integration") && (<Route exact path={path + "/:crud"} component={IntegrationPage} />)} */}

                    <Route exact path={path + '/graphs_analytics'} component={GraphsAnalyticsPage} />
                    <Route exact path={path + '/data_insights'} component={DataInsightsPage} />
                    <Route exact path={path + '/sale_analytics'} component={SaleAnalyticsPage} />
                    <Route exact path={path + "/:crud"} component={BrowsePage} />

                    {/* {module == 'laboratorio' &&(<Route exact path={path + "/:crud/:templatetype/add"} component={LabsEditAddPage} />)} */}
                    <Route exact path={path + "/:crud/add"} component={EditPage} />


                    {/* {module == 'laboratorio' && (this.props.location.pathname).includes("labs") &&(<Route exact path={path + "/:crud/:id"} component={LabsEditAddPage} />)} */}
                    {/* {module == 'laboratorio' && (this.props.location.pathname).includes("labs") &&(<Route exact path={path + "/:crud/view/:id"} component={ReadPageLabs} />)} */}
                    <Route exact path={path + "/:crud/:id"} component={EditPage} />

                    <Route exact path={path + "/:crud/view/:id"} component={ReadPage} />

                </Switch>
            </div>
        );
    }
}

export default withRouter(DefaultDashboardPage);
